import React from 'react';
interface ScarcityBarProps {
  tone?: 'light' | 'dark';
}
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const remaining = 9;
  const percent = 91;
  return <div className="w-full" data-id="element-42" data-mp="2l565ckyelbwf">
      <div className="flex items-baseline justify-between gap-3" data-id="element-43" data-mp="2l3v3wrsfkg8h">
        <span className={`text-[11px] font-bold uppercase tracking-[0.14em] ${tone === 'dark' ? 'text-white/70' : 'text-ink/55'}`} data-id="element-44" data-mp="2q3r7wr14o7o1">
          Promotional spots
        </span>
        <span className="text-[12px] font-extrabold text-alert" data-id="element-45" data-mp="2g63bzxrscu4a">only {remaining} spots left</span>
      </div>
      <div className={`mt-2 h-3 w-full overflow-hidden rounded-full ${tone === 'dark' ? 'bg-white/15' : 'bg-navy/10'}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Promotional spots already claimed" data-id="element-46" data-mp="2273ncq49wf84">
        <div className="h-full rounded-full bg-alert" style={{
        width: `${percent}%`
      }} data-id="element-47" data-mp="5d9zf8qe0y7p" />
      </div>
      <p className={`mt-2 text-[12px] font-semibold ${tone === 'dark' ? 'text-white/70' : 'text-ink/60'}`} data-id="element-48" data-mp="33lbrgvguj450">
        {percent}% of promotional spots already claimed.
      </p>
    </div>;
}